module.exports = __webpack_public_path__ + "static/media/mix_analog.0ed96445.svg";